import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService, SiteService } from 'src/app/services/index';
import { AlertService, Constants } from 'src/app/shared';
import { WarningDialog } from 'src/app/shared/index';
@Component({
  selector: 'app-add-node-tree-configuration-modal',
  templateUrl: './add-node-tree-configuration-modal.component.html',
  styleUrls: ['./add-node-tree-configuration-modal.component.scss']
})
export class AddNodeTreeConfigurationModalComponent
  implements OnInit, AfterViewInit
{
  formData: UntypedFormGroup;
  modalForm: any;
  nodeType: any;
  constant_TEXT = Constants.NODE_TYPE.TEXT;
  constant_METER = Constants.NODE_TYPE.METER;
  constant_PROCESS = Constants.NODE_TYPE.PROCESS;
  constant_TREE_NODE_IMAGE = Constants.DOCUMENT_TYPE.TREE_NODE_IMAGE;
  radioNodeNameIsDisabled = false;
  treeType = {
    STATIC_TREE: 'STATIC_TREE',
    LOAD_ON_TREE: 'LOAD_ON_TREE',
    INVERTER_TREE: 'INVERTER_TREE',
    GENERIC_TREE: 'GENERIC_TREE'
  };
  commonParameters = [
    { text: '%Load(Based on kVA)', value: '%Load(KVA)' },
    { text: 'MachineStatus', value: 'MachineStatus' },
    { text: 'Loss', value: 'Loss' }
  ];
  commonElectricalParameters = [
    { text: 'current', value: 'current' },
    { text: 'realtimepower', value: 'realtimepower' },
    { text: 'realtimeenergy', value: 'realtimeenergy' }
  ];
  meters: any;
  loads: any = [];
  public siteId: string;
  public uploadedFile: any;
  public selectedTreeType: string;
  public nodeInfoModalTitle: string;
  public dashboardNameInputEnabled: boolean;
  public nodeInfoModalMode: number;
  public nodeData: any;
  public processes: any;
  newNodeIdInc = 0;
  nodeInfoModalMode_newFirst = 1;
  nodeInfoModalMode_new = 2;
  nodeInfoModalMode_edit = 3;
  newInverterNodeImgsRId = [];
  removedInverterNodeImgsRId = [];
  selectedMetersRId = [];
  selectedProcessesRId = [];
  currentProcessTreeType = undefined;
  returnData = {
    nodeData: undefined,
    treeData: undefined,
    loadONTreeData: undefined,
    inverterTreeData: undefined,
    genericTreeData: undefined
  };
  formControlIndex = [];
  constructor(
    private dialogRef: MatDialogRef<AddNodeTreeConfigurationModalComponent>,
    private dialog: MatDialog,
    private alertService: AlertService,
    private siteService: SiteService,
    private commonService: CommonService,
    private fb: UntypedFormBuilder
  ) {
    this.nodeType = Constants.NODE_TYPE;
  }

  ngOnInit() {
    const t = this;
    this.formData = this.fb.group({
      nodeTitleCtr: [
        '',
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      dashboardTitleCtr: [],
      // nodeType_NameCtr: [],
      // nodeType_DashboardNameCtr: [],
      // nodeType_MeterCtr: [],
      showInVerticalCtr: [],
      meterCtr: [''],
      processCtr: []
      // paramNameCtr: [],
      // paramConditionOperatorCtr: [],
      // paramConditionValueCtr: [],
      // paramValueSourceCtr: [],
      // paramNodeColorCtr: []
      // rowsAndColumnsCtr: ['', [Validators.required, Validators.min(0), Validators.max(12)]],
    });
    this.modalForm = {
      nodeType: '',
      nodeTitle: '',
      nodeData: this.nodeData,
      selectedLoadParameters: [],
      parameters: [],
      showInVertical: false,
      dashboardTitle: '',
      selectedProcess: {},
      selectedLoad: {},
      selectedMeter: { meterId: '' }
    };

    this.currentProcessTreeType = this.selectedTreeType;
    this.meters = [];
    t.siteService
      .getMetersBySiteIdAndMeterRoles(t.siteId, [
        'Mains',
        'DG',
        'UPS',
        'Load',
        'Harmonic',
        'PDB',
        'Solar'
      ])
      .subscribe((meters) => {
        this.meters = meters;
        for (let i = 0; i < t.processes.length; i++) {
          t.loads = t.loads.concat(t.processes[i].loads);
          // console.log('loads:-' + t.processes[i].loads);
        }
        t.modalForm.selectedLoadParameters = t.commonParameters;
        if (t.nodeInfoModalMode === t.nodeInfoModalMode_edit) {
          // t.modalForm.selectedLoadParameters = t.commonParameters;
          t.modalForm.nodeData = t.nodeData;
          t.modalForm.showInVertical = t.nodeData.showInVertical;
          t.modalForm.nodeTitle = t.nodeData.title;
          t.modalForm.dashboardTitle = t.nodeData.dashboardTitle;
          t.prepareForEdit();
        }
      });
    t.initFormControls();
    // this.siteService.getProcessAndLoadsBySiteId(this.siteId, true).subscribe(function (data) {

    //   t.processes = data;
    //   // t.initLoad();
    //   for (let i = 0; i < t.processes.length; i++) {
    //     t.loads = t.loads.concat(t.processes[i].loads);
    //     console.log('loads:-' + t.processes[i].loads);
    //   }
    //   if (t.nodeInfoModalMode === t.nodeInfoModalMode_edit) {
    //     t.modalForm.selectedLoadParameters = t.commonParameters;
    //     t.modalForm.nodeData = t.nodeData;
    //     t.modalForm.showInVertical = t.nodeData.showInVertical;
    //     t.modalForm.nodeTitle = t.nodeData.title;
    //     t.modalForm.dashboardTitle = t.nodeData.dashboardTitle;
    //     t.prepareForEdit();
    //   }
    // });
  }
  initLoad() {
    for (let i = 0; i < this.processes.length; i++) {
      if (
        this.processes[i].loads !== undefined &&
        this.processes[i].loads.length > 0
      ) {
        this.loads.push(this.processes[i].loads);
      }
    }
  }
  ngAfterViewInit() {}
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: this.returnData });
  }
  resetModalForm() {
    this.modalForm = {
      nodeType: this.nodeType.TEXT
    };
  }
  private initFormControls() {
    for (let i = 0; i < this.modalForm.parameters.length; i++) {
      this.formControlIndex.push(i);
      const paramNameCtr = 'paramNameCtr' + i;
      const paramConditionOperatorCtr = 'paramConditionOperatorCtr' + i;
      const paramConditionValueCtr = 'paramConditionValueCtr' + i;
      const paramValueSourceCtr = 'paramValueSourceCtr' + i;
      const paramNodeColorCtr = 'paramNodeColorCtr' + i;

      if (
        this.commonService.isNullOrUndefined(this.formData.get(paramNameCtr))
      ) {
        this.formData.addControl(paramNameCtr, new UntypedFormControl(''));
      }
      if (
        this.commonService.isNullOrUndefined(
          this.formData.get(paramConditionOperatorCtr)
        )
      ) {
        this.formData.addControl(
          paramConditionOperatorCtr,
          new UntypedFormControl('')
        );
      }
      if (
        this.commonService.isNullOrUndefined(
          this.formData.get(paramConditionValueCtr)
        )
      ) {
        this.formData.addControl(
          paramConditionValueCtr,
          new UntypedFormControl('')
        );
      }
      if (
        this.commonService.isNullOrUndefined(
          this.formData.get(paramValueSourceCtr)
        )
      ) {
        this.formData.addControl(
          paramValueSourceCtr,
          new UntypedFormControl('')
        );
      }
      if (
        this.commonService.isNullOrUndefined(
          this.formData.get(paramNodeColorCtr)
        )
      ) {
        this.formData.addControl(paramNodeColorCtr, new UntypedFormControl(''));
      }
    }
  }
  prepareForEdit() {
    let nodeParameters;
    if (
      this.modalForm.nodeData.meterId !== undefined &&
      this.modalForm.nodeData.meterId !== 'NA'
    ) {
      this.modalForm.nodeType = this.nodeType.METER;
      for (let i = 0; i < this.meters.length; i++) {
        if (this.meters[i].meterId === this.modalForm.nodeData.meterId) {
          this.modalForm.selectedMeter = this.meters[i];
          this.selectMeter();
          nodeParameters = this.modalForm.nodeData.parameters;

          for (
            let j = 0;
            j < this.modalForm.selectedLoadParameters.length;
            j++
          ) {
            const name = this.modalForm.selectedLoadParameters[j].value;
            if (nodeParameters !== undefined) {
              const index = nodeParameters.findIndex(
                (item) => item != null && item.parameterName === name
              );
              // if (index !== -1) {
              //   this.modalForm.parameters.push(nodeParameters[index]);
              // } else {
              //   this.modalForm.parameters.push(undefined);
              // }
              if (index !== -1) {
                this.modalForm.parameters[index] = nodeParameters[index];
              }
            }
          }
          break;
        }
      }
    } else if (
      !this.commonService.isNullOrUndefined(
        this.modalForm.nodeData.processId
      ) &&
      this.modalForm.nodeData.processId !== 'NA'
    ) {
      this.modalForm.nodeType = this.nodeType.PROCESS;
      for (let i = 0; i < this.processes.length; i++) {
        if (this.processes[i].processId === this.modalForm.nodeData.processId) {
          this.modalForm.selectedProcess = this.processes[i];
          break;
        }
      }

      nodeParameters = this.commonParameters.concat(
        this.commonElectricalParameters
      );
      this.modalForm.selectedLoadParameters = nodeParameters;

      nodeParameters = this.modalForm.nodeData.parameters;
      for (let j = 0; j < this.modalForm.selectedLoadParameters.length; j++) {
        const name = this.modalForm.selectedLoadParameters[j].value;
        if (nodeParameters !== undefined) {
          const index = nodeParameters.findIndex(
            (item) => item != null && item.parameterName === name
          );
          if (index !== -1) {
            this.modalForm.parameters.push(nodeParameters[index]);
          } else {
            this.modalForm.parameters.push(undefined);
          }
        }
      }
    } else {
      this.modalForm.nodeType = this.nodeType.TEXT;
      this.modalForm.selectedLoadParameters = [];

      nodeParameters = this.commonParameters.concat(
        this.commonElectricalParameters
      );
      this.modalForm.selectedLoadParameters = nodeParameters;

      nodeParameters = this.modalForm.nodeData.parameters;
      for (let j = 0; j < this.modalForm.selectedLoadParameters.length; j++) {
        const name = this.modalForm.selectedLoadParameters[j].value;
        if (nodeParameters !== undefined) {
          const index = nodeParameters.findIndex(
            (item) => item != null && item.parameterName === name
          );
          if (index !== -1) {
            this.modalForm.parameters.push(nodeParameters[index]);
          } else {
            this.modalForm.parameters.push(undefined);
          }
        }
      }
    }

    if (this.selectedTreeType === this.treeType.INVERTER_TREE) {
      this.uploadedFile = this.modalForm.nodeData.nodeImg;
    }
    this.radioNodeNameIsDisabled =
      this.modalForm.nodeType !== this.nodeType.TEXT;
    this.initFormControls();
  }
  getnodeType() {
    return Constants.NODE_TYPE;
  }
  changeNodeType(radioEvt) {
    this.modalForm.nodeType = radioEvt.value;
    if (this.modalForm.nodeType === this.nodeType.TEXT) {
      this.modalForm.selectedMeter = { meterId: '' };
    } else {
      this.modalForm.nodeTitle = undefined;
    }
  }
  selectChangeMeter() {}
  selectMeter() {
    this.modalForm.selectedLoad = this.getLoadConnectedToMeter(
      this.modalForm.selectedMeter
    );
    if (this.modalForm.selectedLoad !== undefined) {
      this.modalForm.selectedLoadParameters =
        this.commonService.buildLoadParams(
          this.modalForm.selectedLoad.parameters,
          false
        );
      this.modalForm.selectedLoadParameters.push.apply(
        this.modalForm.selectedLoadParameters,
        this.commonParameters
      );
      for (let i = 0; i < this.modalForm.selectedLoadParameters.length; i++) {
        // this.modalForm.parameters.push({ parameterName: this.modalForm.selectedLoadParameters[i].text });
        this.modalForm.parameters.push({ parameterName: '' });
      }
      this.initFormControls();
    }
  }
  getLoadConnectedToMeter(meter) {
    for (let i = 0; i < this.loads.length; i++) {
      const load = this.loads[i];
      if (load.meter !== null && load.meter.meterId === meter.meterId) {
        return load;
      }
    }
    return undefined;
  }

  public selectDocument = (elmId: string) => {
    const element: HTMLElement = document.getElementById(elmId);
    element!.click();
  };
  public uploadDocument = (event: any, pictType: string) => {
    const t = this;
    if (event.target.files.length <= 0) {
      return;
    }
    const files = event.target.files;
    if (!this.commonService.isImageFile(files[0])) {
      this.commonService.showDialogMessage('File type not supported!');
      return;
    }
    const formData = new FormData();
    formData.append('file', files[0]);
    formData.append('documentType', pictType);

    t.siteService
      .uploadDocument(formData, pictType, 'comment', this.siteId)
      .subscribe(
        (data) => {
          if (data === '' || this.commonService.isNullOrUndefined(data)) {
            t.alertService.showError('Upload file fail!');
            return;
          }

          this.uploadedFile = {
            id: data.id,
            name: data.name,
            renderUrl: data.renderUrl
          };
        },
        (data) => {
          t.alertService.showError(
            'Upload file fail! Only upload maximum 2MB per file.'
          );
        }
      );
  };

  generateLoadLeavesForProcessBranch(processData) {
    let nodes;
    for (let i = 0; i < processData.loads.length; i++) {
      const load = processData.loads[i];
      let meterId, meterRole;
      // let meterRId;
      if (load.meter != null) {
        meterId = load.meter.meterId;
        meterRole = load.meter.meterRole;
        // meterRId = load.meter.rId;
      }
      if (this.commonService.isNullOrUndefined(nodes)) {
        nodes = [];
      }
      nodes.push({
        id: this.newNodeIdInc++,
        title: load.name,
        nodes: [],
        // meterRId: meterRId,
        // processRId: undefined,
        // loadRId: load.rId,
        processId: processData.processId,
        meterId: meterId,
        loadId: load.loadId,
        kwRating: load.kwRating,
        type: load.type,
        subType: load.subType,
        meterRole: meterRole,
        nodeType: this.nodeType.LOAD,
        loadName: load.name
      });
    }
    return nodes;
  }

  saveNode() {
    const t = this;
    t.dashboardNameInputEnabled = false;
    const nodeData = t.modalForm.nodeData;
    let nodeImg;
    const parameters =
      t.modalForm.parameters === undefined ? undefined : t.modalForm.parameters;

    if (parameters !== undefined) {
      for (let i = 0; i < parameters.length; i++) {
        if (parameters[i] === undefined) {
          parameters.splice(i, 1);
          break;
        }
      }
    }
    const showInVertical = t.modalForm.showInVertical;
    let nodeTitle;
    let dashboardTitle;
    let meter: any = {};
    let process: any = {};
    let childrenNodes = [];
    let load: any = {};
    if (t.modalForm.nodeType === t.nodeType.TEXT) {
      if (t.modalForm.nodeTitle === '') {
        const dialogRef = this.dialog.open(WarningDialog, { width: '30%' });
        dialogRef.componentInstance.confirmMessage = 'Node Name is required!';

        dialogRef.afterClosed().subscribe((result) => {
          if (!result) {
            console.log(result);
          }
        });
        return;
      }
      nodeTitle = t.modalForm.nodeTitle;
      dashboardTitle =
        t.modalForm.dashboardTitle != null ? t.modalForm.dashboardTitle : null;
    } else if (t.modalForm.nodeType === t.nodeType.PROCESS) {
      nodeTitle = t.modalForm.selectedProcess.name;
      process = t.modalForm.selectedProcess;
    } else {
      // METER
      t.modalForm.selectedLoad = this.getLoadConnectedToMeter(
        t.modalForm.selectedMeter
      );
      nodeTitle = this.commonService.isNullOrUndefined(t.modalForm.selectedLoad)
        ? ''
        : t.modalForm.selectedLoad.name;
      meter = this.commonService.isNullOrUndefined(t.modalForm.selectedMeter)
        ? {}
        : t.modalForm.selectedMeter;
      for (let i = 0; i < t.processes.length; i++) {
        for (let j = 0; j < t.processes[i].loads.length; j++) {
          if (
            t.processes[i].loads[j].meter !== null &&
            t.processes[i].loads[j].meter.meterId === meter.meterId
          ) {
            load = t.processes[i].loads[j];
            break;
          }
        }
        if (load.loadId !== null) {
          break;
        }
      }
    }
    // ADD NEW
    if (t.nodeInfoModalMode === t.nodeInfoModalMode_new) {
      if (t.uploadedFile !== undefined) {
        t.newInverterNodeImgsRId.push(t.uploadedFile.id);
      }
      nodeImg = t.uploadedFile;
      if (meter.meterId !== undefined) {
        t.selectedMetersRId.push(meter.meterId);
      }
      // if (process.rId !== undefined) {
      if (!this.commonService.isNullOrUndefined(process.processId)) {
        t.selectedProcessesRId.push(process.processId);
        childrenNodes = t.generateLoadLeavesForProcessBranch(process);
      }
      if (this.commonService.isNullOrUndefined(nodeData.nodes)) {
        nodeData.nodes = [];
      }
      nodeData.nodes.push({
        id: t.newNodeIdInc++,
        title: nodeTitle,
        nodes: childrenNodes,
        // meterRId: meter.rId,
        // processRId: process.rId,
        processId: process.processId,
        meterId: meter.meterId,
        meterRole: meter.meterRole,
        nodeType: t.modalForm.nodeType,
        loadName: load.name,
        loadId: load.loadId,
        showInVertical: showInVertical,
        nodeImg: nodeImg,
        parameters: parameters,
        dashboardTitle: dashboardTitle
      });
    } else if (t.nodeInfoModalMode === t.nodeInfoModalMode_edit) {
      // EDIT
      if (nodeData.nodeImg !== undefined && t.uploadedFile === undefined) {
        t.removedInverterNodeImgsRId.push(nodeData.nodeImg.id);
      } else if (
        (nodeData === undefined || nodeData.nodeImg === undefined) &&
        t.uploadedFile !== undefined
      ) {
        t.newInverterNodeImgsRId.push(t.uploadedFile.id);
      } else if (
        nodeData.nodeImg !== undefined &&
        t.uploadedFile !== undefined &&
        nodeData.nodeImg.id !== t.uploadedFile.id
      ) {
        t.removedInverterNodeImgsRId.push(nodeData.nodeImg.id);
        t.newInverterNodeImgsRId.push(t.uploadedFile.id);
      }
      nodeImg = t.uploadedFile;
      if (
        nodeData.meterId !== undefined &&
        nodeData.meterId !== meter.meterId
      ) {
        for (let i = 0; i < t.selectedMetersRId.length; i++) {
          if (t.selectedMetersRId[i] === nodeData.meterId) {
            t.selectedMetersRId.splice(i, 1);
            break;
          }
        }
      } else if (
        !this.commonService.isNullOrUndefined(nodeData.processId) &&
        nodeData.processId !== process.processId
      ) {
        for (let i = 0; i < t.selectedProcessesRId.length; i++) {
          if (t.selectedProcessesRId[i] === nodeData.processId) {
            t.selectedProcessesRId.splice(i, 1);
            break;
          }
        }
      }
      if (meter.meterId !== undefined && nodeData.meterId !== meter.meterId) {
        t.selectedMetersRId.push(meter.meterId);
      } else if (
        !this.commonService.isNullOrUndefined(process.processId) &&
        nodeData.processId !== process.processId
      ) {
        t.selectedProcessesRId.push(process.processId);
        childrenNodes = t.generateLoadLeavesForProcessBranch(process);
        nodeData.nodes = childrenNodes;
      }
      nodeData.title = nodeTitle;
      // nodeData.meterRId = meter.rId;
      // nodeData.processRId = process.rId;
      nodeData.processId = process.processId;
      nodeData.meterId = meter.meterId;
      nodeData.meterRole = meter.meterRole;
      nodeData.nodeType = t.modalForm.nodeType;
      nodeData.loadName = load.name;
      nodeData.loadId = load.loadId;
      nodeData.showInVertical = showInVertical;
      nodeData.nodeImg = nodeImg;
      nodeData.parameters = parameters;
      nodeData.dashboardTitle = dashboardTitle;
    } else if (t.nodeInfoModalMode === t.nodeInfoModalMode_newFirst) {
      // ADD FIRST NODE
      if (t.uploadedFile !== undefined) {
        t.newInverterNodeImgsRId.push(t.uploadedFile.id);
      }
      nodeImg = t.uploadedFile;
      if (meter.meterId !== undefined) {
        t.selectedMetersRId.push(meter.meterId);
      }
      if (!this.commonService.isNullOrUndefined(process.processId)) {
        t.selectedProcessesRId.push(process.processId);
        childrenNodes = t.generateLoadLeavesForProcessBranch(process);
      }
      const newTreeData = [
        {
          id: t.newNodeIdInc++,
          title: nodeTitle,
          nodes: childrenNodes,
          // meterRId: meter.rId,
          // processRId: process.rId,
          processId: process.processId,
          meterId: meter.meterId,
          meterRole: meter.meterRole,
          nodeType: t.modalForm.nodeType,
          loadName: load.name,
          loadId: load.loadId,
          showInVertical: showInVertical,
          nodeImg: nodeImg,
          parameters: parameters,
          dashboardTitle: dashboardTitle
        }
      ];

      if (t.currentProcessTreeType === t.treeType.STATIC_TREE) {
        t.returnData.treeData = newTreeData;
      } else if (t.currentProcessTreeType === t.treeType.LOAD_ON_TREE) {
        t.returnData.loadONTreeData = newTreeData;
      } else if (t.currentProcessTreeType === t.treeType.INVERTER_TREE) {
        t.returnData.inverterTreeData = newTreeData;
      } else if (t.currentProcessTreeType === t.treeType.GENERIC_TREE) {
        t.returnData.genericTreeData = newTreeData;
      }
    }
    t.returnData.nodeData = nodeData;
    this.close(true);
  }

  changeParam(parameterName, index) {
    this.modalForm.parameters[index].parameterName = parameterName;
  }

  public isFieldHasError = (fieldName: string, errorCode: string): boolean => {
    return this.formData.get(fieldName).hasError(errorCode);
  };

  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
}
